<template>
    <div class="card-wrapper">
        <div v-if="label" :class="{ card__label: true, 'px-9': $vuetify.breakpoint.smAndUp, 'px-3': $vuetify.breakpoint.xsOnly }">{{ label }}</div>
        <v-card :class="{ 'v-card_bordered': label }">
            <div :class="{ card__body: label }">
                <slot></slot>
            </div>
        </v-card>
    </div>
</template>
<script>
export default {
    props: ['label']
};
</script>
<style>
.card__label {
    width: fit-content;
    background-color: #363e59;
    color: white;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border-radius: 4px 4px 0 0 !important;
    height: 36px;
    line-height: 36px;
    max-width: 450px;
    box-shadow: 0px 0px 1px -2px rgba(0, 0, 0, 0.2), 0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 0px 5px 0px rgba(0, 0, 0, 0.12);
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
}
.v-dialog .card__body {
    max-height: 70vh;
    overflow-y: auto;
}
</style>
